(function () {
  // 12/08: מונה הגולשים הוסר. הוא היה Math.random ולא נתון אמיתי, ובחנות ללא
  // הזמנות דחיפות מומצאת גורמת לגולש להפסיק להאמין גם לשאר הדף.
  // מה שנשאר כאן אמיתי: מלאי נמוך מגיע מ-inventory_quantity, וזמן המשלוח תואם ל-FAQ.
  //
  // 28/08: שורת המשלוח הייתה קבועה, "הזמנה עד 10:00, יישלח היום", והוצגה גם בשבת,
  // גם בשישי בערב וגם אחרי שעת הסגירה. זו הבטחה שלא ניתן לעמוד בה, ולקוח שמגלה
  // את זה אחרי התשלום מגיע לשירות הלקוחות. עכשיו השורה מחושבת לפי היום והשעה
  // בישראל, ומראה את יום המשלוח האמיתי. ימי משלוח: ראשון עד חמישי, סגירה ב-10:00.

  var CUTOFF_HOUR = 10;
  var DAY_NAMES = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];

  // שעון ישראל, ללא תלות בשעון של המכשיר של הגולש
  function israelNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Jerusalem',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
      }).formatToParts(new Date());
      var get = function (t) {
        var p = parts.find(function (x) { return x.type === t; });
        return p ? p.value : '';
      };
      var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var day = map[get('weekday')];
      var hour = parseInt(get('hour'), 10);
      if (day === undefined || isNaN(hour)) return null;
      if (hour === 24) hour = 0;
      return { day: day, hour: hour, minute: parseInt(get('minute'), 10) || 0 };
    } catch (e) {
      return null;
    }
  }

  function isShippingDay(d) {
    return d >= 0 && d <= 4; // ראשון עד חמישי
  }

  // מתי החבילה יוצאת מאיתנו. זה לא מתי היא מגיעה, ולכן תמיד מוצג לידה זמן האספקה.
  function dispatchLine() {
    var now = israelNow();
    // אם משום מה אי אפשר לקרוא את השעה, לא מבטיחים כלום ספציפי
    if (!now) return 'הזמנה עד 10:00 יוצאת למשלוח באותו יום עסקים';

    if (isShippingDay(now.day) && now.hour < CUTOFF_HOUR) {
      var left = (CUTOFF_HOUR * 60) - (now.hour * 60 + now.minute);
      if (left <= 90) {
        var h = Math.floor(left / 60);
        var m = left % 60;
        var t = h > 0 ? (h + ' שעות ו-' + m + ' דקות') : (m + ' דקות');
        return 'נשאר ' + t + ' כדי שההזמנה תצא היום';
      }
      return 'הזמנה עד 10:00 יוצאת למשלוח היום';
    }

    // מוצאים את יום המשלוח הבא
    var next = now.day;
    for (var i = 1; i <= 7; i++) {
      var cand = (now.day + i) % 7;
      if (isShippingDay(cand)) { next = cand; break; }
    }
    if (next === (now.day + 1) % 7) return 'ההזמנה יוצאת למשלוח מחר בבוקר';
    return 'ההזמנה יוצאת למשלוח ביום ' + DAY_NAMES[next];
  }

  var ETA_TEXT = 'זמן אספקה 2 עד 5 ימי עסקים';

  function shippingHtml() {
    return dispatchLine() +
      '<span class="snsei-urg__eta">' + ETA_TEXT + '</span>';
  }

  function inject() {
    const form = document.querySelector('product-form, .product-form');
    if (!form) return;

    // Low stock from Shopify meta if available
    let stockHtml = '';
    try {
      const inv = window.ShopifyAnalytics?.meta?.product?.variants;
      if (inv) {
        const total = inv.reduce((s, v) => s + (v.inventory_quantity || 0), 0);
        if (total > 0 && total <= 7) {
          stockHtml = `<div class="snsei-urg__item snsei-urg__low"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" width="14" height="14" style="display:inline-block;vertical-align:middle;margin-left:4px"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> נותרו רק ${total} יחידות במלאי</div>`;
        }
      }
    } catch(e) {}

    if (!document.getElementById('snsei-urg-eta-css')) {
      var st = document.createElement('style');
      st.id = 'snsei-urg-eta-css';
      st.textContent = '.snsei-urg__eta{display:block;margin-top:.3rem;font-size:1.15rem;opacity:.7;font-weight:400;letter-spacing:.02em}';
      document.head.appendChild(st);
    }

    const strip = document.createElement('div');
    strip.className = 'snsei-urg';
    strip.setAttribute('dir', 'rtl');
    strip.innerHTML = `
      ${stockHtml}
      <div class="snsei-urg__item snsei-urg__ship">${shippingHtml()}</div>`;

    // 05/09/2026, לפי מוטי: קודם כפתור הקנייה, אחריו שורת המשלוח
    form.parentNode.insertBefore(strip, form.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
